// extracted by mini-css-extract-plugin
module.exports = {"categoriesWrapper":"categories_categoriesWrapper__2bHOF"};